import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { routers } from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { QueryClient, QueryClientProvider } from "react-query";
import UserContextProvider from "./App/helper/UserContextProvider";
const queryClient = new QueryClient();
const root = createRoot(document.getElementById("root"));
root.render(
  <>
    <UserContextProvider>
      <QueryClientProvider client={queryClient}>
        <ToastContainer />

        <RouterProvider router={routers} />
      </QueryClientProvider>
    </UserContextProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
